export default __webpack_public_path__ + "static/media/searching-testers.4632bc90.png";